// A tab left open across a deploy still holds the OLD index.js, which then
// requests a lazy chunk hash the new build no longer serves. Browsers word
// that failure differently: Chrome "Failed to fetch dynamically imported
// module", Firefox "error loading dynamically imported module", Safari
// "Importing a module script failed".
const CHUNK_ERROR_PATTERN =
  /dynamically imported module|importing a module script failed|loading chunk .* failed/i;

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_ERROR_PATTERN.test(message);
}

const RELOAD_AT_KEY = 'efacture:chunk-reload-at';

/** A chunk error within this long after the last automatic reload is not reloaded again. */
export const CHUNK_RELOAD_WINDOW_MS = 30_000;

/**
 * Reloads the page for a chunk-load failure unless one was already done in
 * the last CHUNK_RELOAD_WINDOW_MS (a deploy that is genuinely missing the
 * chunk fails again right after the reload). Returns whether it reloaded.
 * Without sessionStorage the guard cannot be kept, so it never reloads.
 */
export function reloadOnceForChunkError(now: number = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_AT_KEY));
    if (last > 0 && now - last < CHUNK_RELOAD_WINDOW_MS) return false;
    sessionStorage.setItem(RELOAD_AT_KEY, String(now));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
